import React, { useState, useEffect, createContext, useRef, useCallback } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Snackbar,
  Alert,
  Menu,
  MenuItem,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Breadcrumbs,
  Link,
  ListItemIcon,
  ListItemText,
  ButtonGroup,
  InputAdornment,
  ListItem,
  FormControlLabel,
  Checkbox,
  Tabs,
  Tab,
  Avatar,
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItemButton,
  FormControl,
  InputLabel,
  Select,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  Folder as FolderIcon,
  InsertDriveFile as FileIcon,
  Edit as EditIcon,
  Download as DownloadIcon,
  Visibility as ViewIcon,
  MoreVert as MoreVertIcon,
  NavigateNext as NavigateNextIcon,
  Clear as ClearIcon,
  Upload as UploadIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  AdminPanelSettings as AdminIcon,
  Edit as EditorIcon,
  Person as UserIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  Menu as MenuIcon,
  DeleteSweep as TrashIcon,
  RestoreFromTrash as RestoreIcon,
  DeleteForever as DeleteForeverIcon
} from '@mui/icons-material';
import FileUpload from './components/FileUpload';
import Login from './components/Login';
import UserManagement from './components/UserManagement';
import StructureManagement from './components/StructureManagement';
import logo from './img/logo.png';
import IDlogo from './img/IDlogo.png';
import { TreeItem } from '@mui/lab';
import bgImg from './img/img.jpg';

// Получаем IP-адрес сервера из URL
const API_URL = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ? window.location.protocol + '//' + window.location.hostname + ':9000'
  : '';

// Константа для ширины боковой панели
const drawerWidth = 240;

const documentTypes = {
  "проектна документація": "Проектна документація",
  "робоча документація": "Робоча документація",
  "проект коригування": "Проект коригування"
};

const fileTypeIcons = {
  document: <FileIcon sx={{ color: 'primary.main' }} />,
  act: <FileIcon sx={{ color: 'secondary.main' }} />
};

const fileTypeLabels = {
  document: "Документ",
  act: "Акт"
};

const categories = {
  "Генеральний план": "Генеральний план",
  "Архітектурні рішення": "Архітектурні рішення",
  "Конструктивні рішення": "Конструктивні рішення",
  "Водопровід та каналізація": "Водопровід та каналізація",
  "Опалення та вентиляція": "Опалення та вентиляція",
  "Холодопостачання": "Холодопостачання",
  "Індивідуальний тепловий пункт": "Індивідуальний тепловий пункт",
  "Електротехнічні рішення": "Електротехнічні рішення",
  "Системи звязку та сигналізації": "Системи звязку та сигналізації",
  "Автоматизація інженерних систем": "Автоматизація інженерних систем",
  "Диспетчеризація інженерних систем": "Диспетчеризація інженерних систем",
  "Системи протипожежного захисту": "Системи протипожежного захисту",
  "Течнологічні рішення": "Течнологічні рішення",
  "Система контролю доступу. Відеоспостереження": "Система контролю доступу. Відеоспостереження",
  "Захист від шуму інженерного обладнання": "Захист від шуму інженерного обладнання",
  "Інженерний захист території": "Інженерний захист території"
};


const projectTypes = {
  "ПЗ": "ПЗ",
  "ГП": "ГП",
  "АР": "АР",
  "КР": "КР",
  "ВК": "ВК",
  "ОВ": "ОВ",
  "ЕТР": "ЕТР",
  "СППЗ": "СППЗ",
  "ТХ": "ТХ",
  "ОВНС": "ОВНС",
  "ПОБ": "ПОБ",
  "РЧЕ": "РЧЕ",
  "Проект захисної смуги": "Проект захисної смуги"
};

export const AuthContext = createContext(null);

const UserRoleIcon = ({ role }) => {
  switch (String(role)) {
    case "1":
      return <AdminIcon sx={{ ml: 1, color: 'primary.main' }} />;
    case "2":
      return <EditorIcon sx={{ ml: 1, color: 'secondary.main' }} />;
    case "3":
      return <UserIcon sx={{ ml: 1, color: 'text.secondary' }} />;
    default:
      return null;
  }
};

function App() {
  // --- ВСЕ ХУКИ ДОЛЖНЫ БЫТЬ ЗДЕСЬ ---
  const [folderStructure, setFolderStructure] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileMenuAnchor, setFileMenuAnchor] = useState(null);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [currentContent, setCurrentContent] = useState([]);
  const [trashFiles, setTrashFiles] = useState([]);
  const [trashLoading, setTrashLoading] = useState(false);
  const [currentPath, setCurrentPath] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([
    { key: 'file_name', label: 'Назва файлу', required: true },
    { key: 'project_code_full', label: 'Повний код', required: true },
    { key: 'project_code_short', label: 'Короткий код', required: true },
    { key: 'sheet_number', label: 'Номер аркуша' },
    { key: 'box_number', label: 'Номер коробки' },
    { key: 'folder_number', label: 'Номер папки' }
  ]);
  const [newUserDialogOpen, setNewUserDialogOpen] = useState(false);
  const [newUserForm, setNewUserForm] = useState({
    username: '',
    password: '',
    access_level: "2"
  });
  const [activeTab, setActiveTab] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Підрахунок загальної кількості файлів
  const totalFilesCount = React.useMemo(() => {
    let count = 0;
    const countFiles = (items) => {
      items.forEach(item => {
        if (item.type === 'file') count++;
        else if (item.children) countFiles(item.children);
      });
    };
    countFiles(folderStructure);
    return count;
  }, [folderStructure]);
  const [editStages, setEditStages] = useState([]);
  const [editCategories, setEditCategories] = useState([]);
  const [editSubcategories, setEditSubcategories] = useState([]);
  const [editProjects, setEditProjects] = useState([]);
  const [editLoading, setEditLoading] = useState(false);
  const editInit = useRef(false);

  // Мемоизируем функцию fetchFolderStructure
  const fetchFolderStructure = useCallback(async () => {
    if (!user) return;

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/folders`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Проверяем тип контента
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('Сервер повернув некоректний формат даних');
      }

      if (!response.ok) {
        if (response.status === 401) {
          setUser(null);
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          throw new Error('Термін дії сесії минув. Увійдіть знову.');
        }
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Помилка завантаження структури папок');
      }

      const data = await response.json();
      // console.log('Ответ от сервера:', data);
      setFolderStructure(data);
      setCurrentContent(data);
      setLoading(false);
    } catch (err) {
      console.error('Помилка при отриманні даних:', err);
      setError(err.message || 'Помилка завантаження структури папок');
      setLoading(false);
    }
  }, [user]);

  // --- ВСЕ useEffect ТАКЖЕ ЗДЕСЬ ---
  useEffect(() => {
    // console.log('Текущий пользователь:', user);
    if (user) {
      fetchFolderStructure();
    }
  }, [user, fetchFolderStructure]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') {
        setFileMenuAnchor(null);
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  useEffect(() => {
    if (currentContent && currentContent.some(item => item.type === 'file')) {
      const files = currentContent.filter(item => item.type === 'file');
      console.log('Files data:', files);
      const columns = [
        { key: 'file_name', label: 'Назва файлу', required: true },
        { key: 'project_code_full', label: 'Повний код', required: true },
        { key: 'project_code_short', label: 'Короткий код', required: true },
        { key: 'sheet_number', label: 'Номер аркуша' },
        { key: 'box_number', label: 'Номер коробки' },
        { key: 'folder_number', label: 'Номер папки' }
      ];
      if (searchResults.length > 0) {
        const additionalColumns = [
          { key: 'stage', label: 'Вид документації' },
          { key: 'project_type', label: 'Тип проекту' },
          { key: 'category', label: 'Категорія' }
        ];
        columns.push(...additionalColumns);
      }
      let visible = columns.filter(column =>
        column.required || files.some(file => file.data && file.data[column.key] && file.data[column.key].trim() !== '')
      );
      
      if (isMobile) {
        // На мобільних пристроях залишаємо лише критичні колонки
        const criticalKeys = ['file_name', 'project_code_full'];
        visible = visible.filter(col => criticalKeys.includes(col.key));
      }

      console.log('Visible columns:', visible);
      setVisibleColumns(visible);
    }
  }, [currentContent, searchResults, isMobile]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fileMenuAnchor && !event.target.closest('.MuiMenu-root')) {
        handleFileMenuClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [fileMenuAnchor]);

  // useEffect для загрузки справочников при открытии диалога редактирования
  useEffect(() => {
    if (editDialogOpen && !editInit.current) {
      setEditLoading(true);
      Promise.all([
        fetchEditStages(),
        fetchEditSubcategories(),
        fetchEditProjects()
      ]).then(() => {
        setEditLoading(false);
        editInit.current = true;
      });
    }
    if (!editDialogOpen) {
      editInit.current = false;
    }
  }, [editDialogOpen]);

  // useEffect для подгрузки категорий при изменении стадии в редактировании
  useEffect(() => {
    if (editDialogOpen && editForm.stage) {
      fetchEditCategories(editForm.stage);
    }
  }, [editDialogOpen, editForm.stage]);

  // Динамический поиск по мере ввода
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchQuery.trim()) {
        handleSearch(searchQuery);
      } else {
        setSearchResults([]);
      }
    }, 400); // debounce 400ms
    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  const fetchTrashFiles = useCallback(async () => {
    try {
      setTrashLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/trash`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setTrashFiles(data);
      }
      setTrashLoading(false);
    } catch (err) {
      console.error('Помилка завантаження кошика:', err);
      setTrashLoading(false);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 3) {
      fetchTrashFiles();
    }
  }, [activeTab, fetchTrashFiles]);

  // --- ПРАВА ДОСТУПА ---
  const isAdmin = String(user?.access_level) === "1";
  const isEditor = String(user?.access_level) === "2";
  const canManageDocuments = isAdmin || isEditor;

  // --- функции-обработчики ---
  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  // --- ТОЛЬКО ПОСЛЕ ВСЕХ ХУКОВ ---
  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const authContextValue = {
    user,
    handleLogin,
    handleLogout
  };

  const handleFolderClick = (folder) => {
    if (!folder.name && folder.children) {
      setCurrentContent(folder.children);
      setCurrentPath([]);
    } else {
      const existingIndex = currentPath.findIndex(p => p.name === folder.name);
      if (existingIndex !== -1) {
        const newPath = currentPath.slice(0, existingIndex + 1);
        setCurrentPath(newPath);
      } else {
        const newPath = [...currentPath, folder];
        setCurrentPath(newPath);
      }

      // Проверяем, есть ли подпапки в category
      if (folder.type === 'category' && folder.children) {
        // Сортируем подпапки по типу
        const sortedChildren = [...folder.children].sort((a, b) => {
          const typeOrder = {
            'type': 0,
            'file': 1
          };
          return typeOrder[a.type] - typeOrder[b.type];
        });
        setCurrentContent(sortedChildren);
      } else {
        setCurrentContent(folder.children);
      }
    }
  };

  const handleBreadcrumbClick = (index) => {
    const newPath = currentPath.slice(0, index + 1);
    setCurrentPath(newPath);

    let content = folderStructure;
    for (let i = 0; i <= index; i++) {
      const nextFolder = content.find(item => item.name === newPath[i].name);
      if (nextFolder) {
        if (nextFolder.type === 'category' && nextFolder.children) {
          // Сортируем подпапки по типу
          content = [...nextFolder.children].sort((a, b) => {
            const typeOrder = {
              'type': 0,
              'file': 1
            };
            return typeOrder[a.type] - typeOrder[b.type];
          });
        } else {
          content = nextFolder.children;
        }
      }
    }
    setCurrentContent(content);
  };

  const handleFileMenuClick = (event, file) => {
    event.stopPropagation();
    // console.log('Открытие меню файла:', file);
    setSelectedFile(file);
    setFileMenuAnchor(event.currentTarget);
  };

  const handleFileMenuClose = () => {
    // console.log('Закрытие меню файла');
    setFileMenuAnchor(null);
    setSelectedFile(null);
  };

  const handleOpenFile = async () => {
    if (!selectedFile) return;

    try {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (!currentUser) {
        throw new Error('Пользователь не найден');
      }

      const filePath = selectedFile.data.file_path || '';
      let fileTarget = filePath;
      if (filePath.includes('/docs/')) {
        fileTarget = filePath.split('/docs/').pop();
      }

      const token = localStorage.getItem('token');
      window.open(
        `${API_URL}/api/files/${encodeURIComponent(fileTarget)}?token=${token}`,
        '_blank'
      );
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Помилка при відкритті файлу',
        severity: 'error'
      });
    }
  };

  const handleViewFile = handleOpenFile;

  const handleDownloadFile = async () => {
    if (!selectedFile) return;

    try {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (!currentUser) {
        throw new Error('Пользователь не найден');
      }

      const filePath = selectedFile.data.file_path || '';
      let fileTarget = filePath;
      if (filePath.includes('/docs/')) {
        fileTarget = filePath.split('/docs/').pop();
      }

      const token = localStorage.getItem('token');
      window.open(
        `${API_URL}/api/files/${encodeURIComponent(fileTarget)}?download=true&token=${token}`,
        '_blank'
      );
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Помилка при завантаженні файлу',
        severity: 'error'
      });
    }
  };

  // Функция поиска id категории по названию
  const getCategoryIdByName = (name) => {
    const cat = editCategories.find(c => c.name === name);
    return cat ? cat.id : '';
  };

  const handleEditFile = async (file) => {
    // console.log('Попытка редактирования файла:', file);
    // console.log('Текущий пользователь:', user);

    if (!canManageDocuments) {
      console.log('Відмовлено в доступі до редагування');
      setSnackbar({
        open: true,
        message: 'Недостатньо прав для редагування документа',
        severity: 'error'
      });
      return;
    }

    if (!file || !file.data) {
      console.error('Відсутні дані файлу для редагування');
      setSnackbar({
        open: true,
        message: 'Помилка: неможливо редагувати файл',
        severity: 'error'
      });
      return;
    }

    try {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (!currentUser) throw new Error('Користувач не знайдений');

      // Получаем полные данные файла через новый эндпоинт
      const response = await fetch(`${API_URL}/api/projects/${file.data.id}/data?user_id=${currentUser.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Помилка отримання даних файлу');
      }

      const fileData = await response.json();
      // console.log('Отримані повні дані файлу:', fileData);

      setSelectedFile(file);
      setEditForm({
        id: file.data.id,
        file_name: fileData.file_name,
        stage: fileData.stage_id,
        category: fileData.category_id,
        type: fileData.type_id,
        project_name: fileData.project_name,
        project_code_full: fileData.project_code_full,
        project_code_short: fileData.project_code_short,
        sheet_number: fileData.sheet_number,
        is_separate_doc: fileData.is_separate_doc,
        box_number: fileData.box_number,
        folder_number: fileData.folder_number
      });
      setEditDialogOpen(true);
    } catch (error) {
      console.error('Помилка при отриманні даних файлу:', error);
      setSnackbar({
        open: true,
        message: error.message,
        severity: 'error'
      });
    }
  };

  const handleEditStageChange = (e) => {
    const stageId = e.target.value;
    setEditForm({ ...editForm, stage: stageId, category: '', type: '' });
    fetchEditCategories(stageId);
  };

  const handleEditCategoryChange = (e) => {
    setEditForm({ ...editForm, category: e.target.value });
  };

  const handleEditTypeChange = (e) => {
    setEditForm({ ...editForm, type: e.target.value });
  };

  const handleEditProjectChange = (e) => {
    setEditForm({ ...editForm, project_name: e.target.value });
  };

  const handleEditSubmit = async () => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (!currentUser) throw new Error('Користувач не знайдений');
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/files/${editForm.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          file_name: editForm.file_name,
          stage: editForm.stage,
          category: editForm.category,
          type: editForm.type,
          project_name: editForm.project_name,
          project_code_full: editForm.project_code_full,
          project_code_short: editForm.project_code_short,
          sheet_number: editForm.sheet_number,
          is_separate_doc: editForm.is_separate_doc,
          box_number: editForm.box_number,
          folder_number: editForm.folder_number
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Помилка оновлення файлу');
      }

      setEditDialogOpen(false);
      fetchFolderStructure();
      setSnackbar({
        open: true,
        message: 'Файл успішно оновлено',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: 'error'
      });
    }
  };

  const handleSearch = async (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }

    try {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (!currentUser) throw new Error('Користувач не знайдений');
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/search?query=${encodeURIComponent(query)}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setSearchResults(data.map(file => ({
        name: file.file_name,
        type: 'file',
        data: file,
        path: findFilePath(folderStructure, file.id)
      })));
    } catch (err) {
      console.error('Помилка пошуку:', err);
    }
  };

  const findFilePath = (structure, fileId) => {
    for (const stage of structure) {
      if (stage.type === 'stage') {
        if (stage.name === "проектна документація") {
          for (const projectType of stage.children) {
            const file = projectType.children.find(f => f.data && f.data.id === fileId);
            if (file) {
              return [stage, projectType];
            }
          }
        } else if (stage.name === "робоча документація") {
          for (const category of stage.children) {
            const file = category.children.find(f => f.data && f.data.id === fileId);
            if (file) {
              return [stage, category];
            }
          }
        } else {
          const file = stage.children.find(f => f.data && f.data.id === fileId);
          if (file) {
            return [stage];
          }
        }
      }
    }
    return null;
  };

  const handleSearchResultClick = (file) => {
    if (file.path) {
      setCurrentPath(file.path);
      setCurrentContent(file.path[file.path.length - 1].children);
    }
  };

  const handleUploadSuccess = () => {
    fetchFolderStructure();
    setSnackbar({
      open: true,
      message: 'Файл успішно завантажено',
      severity: 'success'
    });
  };

  const handleStageChange = (e) => {
    const newStage = e.target.value;
    setEditForm({
      ...editForm,
      stage: newStage,
      category: newStage === "робоча документація" ? editForm.category : "",
      project_type: newStage === "проектна документація" ? editForm.project_type : ""
    });
  };

  const handleDeleteClick = (file) => {
    setFileToDelete(file);
    setDeleteDialogOpen(true);
    handleFileMenuClose();
  };

  const handleDeleteConfirm = async () => {
    if (!fileToDelete) return;

    try {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (!currentUser) throw new Error('Користувач не знайдений');
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/files/${fileToDelete.data.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        setSnackbar({
          open: true,
          message: 'Файл успішно видалено',
          severity: 'success'
        });
        fetchFolderStructure();
      } else {
        throw new Error('Помилка видалення файлу');
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: 'Помилка видалення файлу',
        severity: 'error'
      });
    }

    setDeleteDialogOpen(false);
    setFileToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setFileToDelete(null);
  };

  const resetNewUserForm = () => {
    setNewUserForm({
      username: '',
      password: '',
      access_level: "2"
    });
  };

  const handleCreateUser = async () => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('user'));
      if (!currentUser) throw new Error('Користувач не знайдений');
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newUserForm)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Помилка створення користувача');
      }

      setSnackbar({
        open: true,
        message: 'Користувач успішно створений',
        severity: 'success'
      });
      setNewUserDialogOpen(false);
      resetNewUserForm();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message,
        severity: 'error'
      });
    }
  };

  const tableStyles = {
    maxWidth: '100%',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    '& .MuiTable-root': {
      minWidth: isMobile ? 500 : 800,
    },
    '& .MuiTableCell-root': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: isMobile ? '120px' : '200px',
      px: isMobile ? 1 : 2,
    }
  };

  // Функции для загрузки справочников для редактирования
  const fetchEditStages = async () => {
    const res = await fetch(`${API_URL}/api/stages`);
    setEditStages(await res.json());
  };
  const fetchEditCategories = async (stageId) => {
    const res = await fetch(`${API_URL}/api/categories?stage_id=${stageId}`);
    setEditCategories(await res.json());
  };
  const fetchEditSubcategories = async () => {
    const res = await fetch(`${API_URL}/api/subcategories`);
    setEditSubcategories(await res.json());
  };
  const fetchEditProjects = async () => {
    const res = await fetch(`${API_URL}/api/prj`);
    setEditProjects(await res.json());
  };

  const renderFolderStructure = (items) => {
    return items.map((item, index) => {
      if (item.type === 'project') {
        return (
          <TreeItem
            key={`${item.name}-${index}`}
            nodeId={`project-${item.name}`}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FolderIcon sx={{ color: 'primary.main', mr: 1 }} />
                <Typography>{item.name}</Typography>
              </Box>
            }
          >
            {item.children && renderFolderStructure(item.children)}
          </TreeItem>
        );
      } else if (item.type === 'stage') {
        return (
          <TreeItem
            key={`${item.name}-${index}`}
            nodeId={`stage-${item.name}`}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FolderIcon sx={{ color: 'secondary.main', mr: 1 }} />
                <Typography>{item.name}</Typography>
              </Box>
            }
          >
            {item.children && renderFolderStructure(item.children)}
          </TreeItem>
        );
      } else if (item.type === 'category') {
        return (
          <TreeItem
            key={`${item.name}-${index}`}
            nodeId={`category-${item.name}`}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FolderIcon sx={{ color: 'info.main', mr: 1 }} />
                <Typography>{item.name}</Typography>
              </Box>
            }
          >
            {item.children && renderFolderStructure(item.children)}
          </TreeItem>
        );
      } else if (item.type === 'type') {
        return (
          <TreeItem
            key={`${item.name}-${index}`}
            nodeId={`type-${item.name}`}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FolderIcon sx={{ color: 'success.main', mr: 1 }} />
                <Typography>{item.name}</Typography>
              </Box>
            }
          >
            {item.children && renderFolderStructure(item.children)}
          </TreeItem>
        );
      } else if (item.type === 'file') {
        const fileType = item.data.type === 1 ? 'document' : 'act';
        return (
          <TreeItem
            key={`${item.name}-${index}`}
            nodeId={`file-${item.data.id}`}
            label={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover': {
                    backgroundColor: 'action.hover',
                  },
                }}
                onContextMenu={(e) => handleFileContextMenu(e, item)}
              >
                {fileTypeIcons[fileType]}
                <Typography sx={{ ml: 1 }}>{item.name}</Typography>
              </Box>
            }
            onClick={() => handleFileClick(item)}
          />
        );
      }
      return null;
    });
  };

  const handleFileContextMenu = (event, file) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedFile(file);
    setFileMenuAnchor(event.currentTarget);
  };

  const handleFileClick = (file) => {
    if (file.type === 'file') {
      handleViewFile();
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <AuthContext.Provider value={authContextValue}>
      <Box sx={{ minHeight: '100vh', position: 'relative' }}>
        <Box sx={{ display: 'flex' }}>
          <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar>
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                <img src={logo} alt="logo" style={{ height: 40, borderRadius: 6, marginRight: 12 }} />
              </Box>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={() => setDrawerOpen(true)}
                sx={{ mr: 2, display: { md: 'none' } }}
              >
                <MenuIcon />
              </IconButton>
              <Typography 
                variant="h6" 
                noWrap 
                component="div"
                sx={{ 
                  fontSize: { xs: '0.9rem', sm: '1.25rem' },
                  display: 'block'
                }}
              >
                {isMobile ? "IDocumentum" : "Система управління документами"}
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              {user && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
                  <Typography variant="body1" sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1 }}>
                    {user.username}
                    <UserRoleIcon role={user.access_level} />
                  </Typography>
                  {isMobile && <UserRoleIcon role={user.access_level} />}
                  <Button 
                    color="inherit" 
                    onClick={handleLogout}
                    size={isMobile ? "small" : "medium"}
                  >
                    Вийти
                  </Button>
                </Box>
              )}
            </Toolbar>
          </AppBar>
          <Drawer
            variant="temporary"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: 'block', md: 'none' },
              '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
              zIndex: (theme) => theme.zIndex.appBar + 1,
            }}
          >
            <Toolbar />
            <Box sx={{ overflow: 'auto' }}>
              <List>
                <ListItem disablePadding>
                  <ListItemButton
                    selected={activeTab === 0}
                    onClick={() => { setActiveTab(0); setDrawerOpen(false); }}
                  >
                    <ListItemIcon>
                      <FolderIcon />
                    </ListItemIcon>
                    <ListItemText primary="Документи" />
                  </ListItemButton>
                </ListItem>
                {isAdmin && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton
                        selected={activeTab === 1}
                        onClick={() => { setActiveTab(1); setDrawerOpen(false); }}
                      >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Користувачі" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton
                        selected={activeTab === 2}
                        onClick={() => { setActiveTab(2); setDrawerOpen(false); }}
                      >
                        <ListItemIcon>
                          <SettingsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Структура" />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}
                {canManageDocuments && (
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={activeTab === 3}
                      onClick={() => { setActiveTab(3); setDrawerOpen(false); }}
                    >
                      <ListItemIcon>
                        <TrashIcon color={activeTab === 3 ? "primary" : "inherit"} />
                      </ListItemIcon>
                      <ListItemText primary="Кошик" />
                    </ListItemButton>
                  </ListItem>
                )}
              </List>
            </Box>
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              display: { xs: 'none', md: 'block' },
              [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
            open
          >
            <Toolbar />
            <Box sx={{ overflow: 'auto' }}>
              <List>
                <ListItem disablePadding>
                  <ListItemButton
                    selected={activeTab === 0}
                    onClick={() => setActiveTab(0)}
                  >
                    <ListItemIcon>
                      <FolderIcon />
                    </ListItemIcon>
                    <ListItemText primary="Документи" />
                  </ListItemButton>
                </ListItem>
                {isAdmin && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton
                        selected={activeTab === 1}
                        onClick={() => setActiveTab(1)}
                      >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Користувачі" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton
                        selected={activeTab === 2}
                        onClick={() => setActiveTab(2)}
                      >
                        <ListItemIcon>
                          <SettingsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Структура" />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}
                {canManageDocuments && (
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={activeTab === 3}
                      onClick={() => setActiveTab(3)}
                    >
                      <ListItemIcon>
                        <TrashIcon color={activeTab === 3 ? "primary" : "inherit"} />
                      </ListItemIcon>
                      <ListItemText primary="Кошик" />
                    </ListItemButton>
                  </ListItem>
                )}
              </List>
            </Box>
          </Drawer>
          <Box component="main" sx={{ 
            flexGrow: 1, 
            p: { xs: 1.5, sm: 2, md: 3 },
            width: { xs: '100%', md: `calc(100% - ${drawerWidth}px)` },
            overflowX: 'hidden'
          }}>
            <Toolbar />
            {activeTab === 0 && (
              <>
                <Box
                  sx={{
                    minHeight: { xs: 120, sm: 160 },
                    backgroundImage: `url(${bgImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    borderRadius: 2,
                    mb: 2,
                    px: { xs: 2, sm: 4 },
                    py: { xs: 2, sm: 4 },
                  }}
                >
                  <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'stretch', sm: 'center' },
                    gap: 2
                  }}>
                    <Box>
                      <Typography
                        variant="h4"
                        component="h1"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, color: '#fff', textShadow: '0 1px 8px #0007', mb: 0 }}
                      >
                        Документи проекту
                      </Typography>
                      <Typography variant="subtitle1" sx={{ color: '#rgba(255,255,255,0.9)', textShadow: '0 1px 4px #0007' }}>
                        Всього файлів: {totalFilesCount}
                      </Typography>
                    </Box>
                    {canManageDocuments && (
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<UploadIcon />}
                        onClick={() => setOpenUploadDialog(true)}
                        fullWidth={isMobile}
                        sx={{ boxShadow: 2, py: isMobile ? 1 : 1.5 }}
                      >
                        Додати документ
                      </Button>
                    )}
                  </Box>
                </Box>

                <Paper sx={{ p: { xs: 1, sm: 2 }, mb: 2 }}>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    mb: 2
                  }}>
                    <TextField
                      fullWidth
                      label="Пошук"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      size={isMobile ? "small" : "medium"}
                      InputProps={{
                        endAdornment: searchQuery && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                setSearchQuery('');
                                setSearchResults([]);
                                setCurrentPath([]);
                                setCurrentContent(folderStructure);
                              }}
                              size="small"
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Paper>

                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  maxItems={isMobile ? 2 : 4}
                  itemsAfterCollapse={isMobile ? 1 : 2}
                  itemsBeforeCollapse={isMobile ? 1 : 2}
                  sx={{
                    mb: 2,
                    '& .MuiBreadcrumbs-ol': {
                      flexWrap: 'wrap'
                    },
                    '& .MuiBreadcrumbs-li': {
                      fontSize: { xs: '0.875rem', sm: '1rem' }
                    }
                  }}
                >
                  <Link
                    component="button"
                    variant="body1"
                    onClick={() => {
                      setCurrentPath([]);
                      setCurrentContent(folderStructure);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    Коренева папка
                  </Link>
                  {currentPath.filter((folder, index) =>
                    currentPath.findIndex(p => p.name === folder.name) === index
                  ).map((folder, index) => (
                    <Link
                      key={folder.name + index}
                      component="button"
                      variant="body1"
                      onClick={() => handleBreadcrumbClick(index)}
                      sx={{ cursor: 'pointer' }}
                    >
                      {folder.name}
                    </Link>
                  ))}
                </Breadcrumbs>

                <Paper elevation={3} sx={{ p: { xs: 1, sm: 2 } }}>
                  {searchResults.length > 0 ? (
                    <TableContainer sx={{ mt: 2, ...tableStyles }}>
                      <Table size={isMobile ? "small" : "medium"}>
                        <TableHead>
                          <TableRow>
                            <TableCell align="right">Дії</TableCell>
                            {visibleColumns.map((column) => (
                              <TableCell key={column.key}>{column.label}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {searchResults.map((file, index) => (
                            <TableRow key={index}>
                              <TableCell align="right">
                                <ButtonGroup size="small" variant="text">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => handleFileMenuClick(e, file)}
                                    title="Дії з файлом"
                                  >
                                    <MoreVertIcon />
                                  </IconButton>
                                </ButtonGroup>
                              </TableCell>
                              {visibleColumns.map((column) => (
                                <TableCell key={column.key}>
                                  {file.data && file.data[column.key]}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <>
                      {currentContent.some(item => item.type !== 'file') ? (
                        <Grid container spacing={{ xs: 2, sm: 3 }} justifyContent="flex-start" alignItems="stretch" wrap="wrap">
                          {currentContent
                            .filter(item => item.type !== 'file' && item.name)
                            .sort((a, b) => {
                              const typeOrder = {
                                'project': 0,
                                'stage': 1,
                                'category': 2,
                                'type': 3
                              };
                              return typeOrder[a.type] - typeOrder[b.type];
                            })
                            .map((folder, index) => (
                              <Grid item xs={6} sm={6} md={4} key={index}>
                                <Card sx={{ 
                                  height: { xs: 160, sm: 220 }, 
                                  width: '100%', 
                                  display: 'flex', 
                                  flexDirection: 'column', 
                                  justifyContent: 'center', 
                                  alignItems: 'center', 
                                  boxShadow: 2,
                                  transition: 'transform 0.2s',
                                  '&:hover': { transform: 'scale(1.02)' }
                                }}>
                                  <CardActionArea onClick={() => handleFolderClick(folder)} sx={{ height: '100%' }}>
                                    <CardContent sx={{
                                      textAlign: 'center',
                                      height: '100%',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      p: 2
                                    }}>
                                      <FolderIcon sx={{
                                        fontSize: { xs: 36, sm: 48 },
                                        color: folder.type === 'project' ? 'primary.main' :
                                          folder.type === 'stage' ? 'secondary.main' :
                                            folder.type === 'category' ? 'info.main' :
                                              'success.main',
                                        mb: 1
                                      }} />
                                      <Typography
                                        variant="body1"
                                        component="div"
                                        sx={{
                                          fontSize: '1rem',
                                          lineHeight: 1.3,
                                          mt: 1,
                                          display: '-webkit-box',
                                          WebkitLineClamp: 7,
                                          WebkitBoxOrient: 'vertical',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxHeight: '9.1em',
                                          minHeight: '9.1em',
                                          wordBreak: 'break-word',
                                          whiteSpace: 'normal',
                                          width: '100%',
                                          px: 1
                                        }}
                                      >
                                        {folder.name}
                                      </Typography>
                                    </CardContent>
                                  </CardActionArea>
                                </Card>
                              </Grid>
                            ))}
                        </Grid>
                      ) : null}

                      {currentContent.some(item => item.type === 'file') && (
                        <TableContainer sx={{ mt: 2, ...tableStyles }}>
                          <Table size={isMobile ? "small" : "medium"}>
                            <TableHead>
                              <TableRow>
                                <TableCell align="right">Дії</TableCell>
                                {visibleColumns.map((column) => (
                                  <TableCell key={column.key}>{column.label}</TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {currentContent
                                .filter(item => item.type === 'file')
                                .map((file, index) => (
                                  <TableRow key={index}>
                                    <TableCell align="right">
                                      <ButtonGroup size="small" variant="text">
                                        <IconButton
                                          size="small"
                                          onClick={(e) => handleFileMenuClick(e, file)}
                                          title="Дії з файлом"
                                        >
                                          <MoreVertIcon />
                                        </IconButton>
                                      </ButtonGroup>
                                    </TableCell>
                                    {visibleColumns.map((column) => (
                                      <TableCell key={column.key}>
                                        {file.data && file.data[column.key]}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </>
                  )}
                </Paper>
              </>
            )}
            {activeTab === 1 && isAdmin && (
              <>
                <Box
                  sx={{
                    minHeight: { xs: 120, sm: 160 },
                    backgroundImage: `url(${bgImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    borderRadius: 2,
                    mb: 2,
                    px: { xs: 2, sm: 4 },
                    py: { xs: 2, sm: 4 },
                  }}
                >
                  <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, color: '#fff', textShadow: '0 1px 8px #0007' }}
                  >
                    Користувачі
                  </Typography>
                </Box>
                <UserManagement />
              </>
            )}
            {activeTab === 2 && isAdmin && (
              <>
                <Box
                  sx={{
                    minHeight: { xs: 120, sm: 160 },
                    backgroundImage: `url(${bgImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    borderRadius: 2,
                    mb: 2,
                    px: { xs: 2, sm: 4 },
                    py: { xs: 2, sm: 4 },
                  }}
                >
                  <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, color: '#fff', textShadow: '0 1px 8px #0007' }}
                  >
                    Структура
                  </Typography>
                </Box>
                <StructureManagement userRole={user.access_level} />
              </>
            )}
            <Menu
              anchorEl={fileMenuAnchor}
              open={Boolean(fileMenuAnchor)}
              onClose={handleFileMenuClose}
            >
              <MenuItem onClick={handleViewFile}>
                <ListItemIcon>
                  {selectedFile?.type === 'document' ? (
                    <ViewIcon fontSize="small" color="primary" />
                  ) : (
                    <ViewIcon fontSize="small" color="secondary" />
                  )}
                </ListItemIcon>
                <ListItemText primary="Переглянути" />
              </MenuItem>
              <MenuItem onClick={handleDownloadFile}>
                <ListItemIcon>
                  {selectedFile?.type === 'document' ? (
                    <DownloadIcon fontSize="small" color="primary" />
                  ) : (
                    <DownloadIcon fontSize="small" color="secondary" />
                  )}
                </ListItemIcon>
                <ListItemText primary="Завантажити" />
              </MenuItem>
              {canManageDocuments && (
                <>
                  <MenuItem onClick={() => handleEditFile(selectedFile)}>
                    <ListItemIcon>
                      <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Редагувати" />
                  </MenuItem>
                  <MenuItem onClick={() => handleDeleteClick(selectedFile)}>
                    <ListItemIcon>
                      <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Видалити" />
                  </MenuItem>
                </>
              )}
            </Menu>

            <FileUpload
              open={openUploadDialog}
              onClose={() => setOpenUploadDialog(false)}
              onUpload={handleUploadSuccess}
              userRole={user?.access_level}
            />

            <Dialog
              open={deleteDialogOpen}
              onClose={handleDeleteCancel}
            >
              <DialogTitle>Підтвердження видалення</DialogTitle>
              <DialogContent>
                <Typography>
                  Ви впевнені, що хочете видалити файл "{fileToDelete?.data?.file_name}"?
                  Ця дія не може бути скасована.
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDeleteCancel}>Скасувати</Button>
                <Button onClick={handleDeleteConfirm} color="error">
                  Видалити
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={editDialogOpen}
              onClose={() => setEditDialogOpen(false)}
            >
              <DialogTitle>Редагування файлу</DialogTitle>
              <DialogContent>
                <Box sx={{ pt: 2 }}>
                  <TextField
                    fullWidth
                    label="Назва файлу"
                    value={editForm.file_name || ''}
                    onChange={(e) => setEditForm({ ...editForm, file_name: e.target.value })}
                    sx={{ mb: 2 }}
                  />
                  <FormControl fullWidth required sx={{ mb: 2 }}>
                    <InputLabel>Вид документації</InputLabel>
                    <Select
                      value={editForm.stage || ''}
                      onChange={handleEditStageChange}
                      label="Вид документації"
                    >
                      {editStages.map((stage) => (
                        <MenuItem key={stage.id} value={stage.id}>{stage.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Категорія</InputLabel>
                    <Select
                      value={editForm.category || ''}
                      onChange={handleEditCategoryChange}
                      label="Категорія"
                    >
                      {editCategories.map((cat) => (
                        <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth required sx={{ mb: 2 }}>
                    <InputLabel>Тип документа</InputLabel>
                    <Select
                      value={editForm.type || ''}
                      onChange={handleEditTypeChange}
                      label="Тип документа"
                    >
                      {editSubcategories.map((sub) => (
                        <MenuItem key={sub.id} value={sub.id}>{sub.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Код проекту (повний)"
                    value={editForm.project_code_full || ''}
                    onChange={(e) => setEditForm({ ...editForm, project_code_full: e.target.value })}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Код проекту (скорочений)"
                    value={editForm.project_code_short || ''}
                    onChange={(e) => setEditForm({ ...editForm, project_code_short: e.target.value })}
                    sx={{ mb: 2 }}
                  />
                  <FormControl fullWidth required sx={{ mb: 2 }}>
                    <InputLabel>Назва проекту</InputLabel>
                    <Select
                      value={editForm.project_name || ''}
                      onChange={handleEditProjectChange}
                      label="Назва проекту"
                    >
                      {editProjects.map((prj) => (
                        <MenuItem key={prj.id} value={prj.name}>{prj.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Номер аркуша"
                    value={editForm.sheet_number || ''}
                    onChange={(e) => setEditForm({ ...editForm, sheet_number: e.target.value })}
                    sx={{ mb: 2 }}
                  />
                  <FormControl sx={{ mb: 2, width: "100%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={editForm.is_separate_doc === 1}
                          onChange={(e) => setEditForm({ ...editForm, is_separate_doc: e.target.checked ? 1 : 0 })}
                        />
                      }
                      label="Окремий документ"
                    />
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Номер коробки"
                    value={editForm.box_number || ''}
                    onChange={(e) => setEditForm({ ...editForm, box_number: e.target.value })}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Номер папки"
                    value={editForm.folder_number || ''}
                    onChange={(e) => setEditForm({ ...editForm, folder_number: e.target.value })}
                    sx={{ mb: 2 }}
                  />
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setEditDialogOpen(false)}>Скасувати</Button>
                <Button onClick={handleEditSubmit} variant="contained" color="primary">
                  Зберегти
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={newUserDialogOpen}
              onClose={() => setNewUserDialogOpen(false)}
            >
              <DialogTitle>Додати нового користувача</DialogTitle>
              <DialogContent>
                <Box sx={{ pt: 2 }}>
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Ім'я користувача"
                    type="text"
                    fullWidth
                    value={newUserForm.username}
                    onChange={(e) => setNewUserForm({ ...newUserForm, username: e.target.value })}
                    required
                  />
                  <TextField
                    margin="dense"
                    label="Пароль"
                    type="password"
                    fullWidth
                    value={newUserForm.password}
                    onChange={(e) => setNewUserForm({ ...newUserForm, password: e.target.value })}
                    required
                  />
                  <TextField
                    select
                    margin="dense"
                    label="Роль користувача"
                    fullWidth
                    value={newUserForm.access_level}
                    onChange={(e) => setNewUserForm({
                      ...newUserForm,
                      access_level: e.target.value
                    })}
                    required
                    sx={{ mt: 2 }}
                  >
                    <MenuItem value="1">Адміністратор (повний доступ)</MenuItem>
                    <MenuItem value="2">Редактор (перегляд та редагування)</MenuItem>
                    <MenuItem value="3">Користувач (тільки перегляд та завантаження)</MenuItem>
                  </TextField>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setNewUserDialogOpen(false)}>Скасувати</Button>
                <Button onClick={handleCreateUser} variant="contained" color="primary">
                  Створити
                </Button>
              </DialogActions>
            </Dialog>

            {activeTab === 3 && (
              <Box sx={{ p: { xs: 1, sm: 2 } }}>
                <Typography variant="h5" sx={{ mb: 2 }}>Кошик</Typography>
                <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                  <Table size={isMobile ? "small" : "medium"}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Назва файлу</TableCell>
                        <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Проект</TableCell>
                        <TableCell align="right">Дії</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {trashFiles.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={3} align="center">
                            {trashLoading ? "Завантаження..." : "Кошик порожній"}
                          </TableCell>
                        </TableRow>
                      ) : (
                        trashFiles.map((file) => (
                          <TableRow key={file.id}>
                            <TableCell>{file.file_name}</TableCell>
                            <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{file.project_name}</TableCell>
                            <TableCell align="right">
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                <IconButton 
                                  color="primary" 
                                  title="Відновити"
                                  onClick={async () => {
                                    const token = localStorage.getItem('token');
                                    const res = await fetch(`${API_URL}/api/trash/restore/${file.id}`, {
                                      method: 'POST',
                                      headers: { 'Authorization': `Bearer ${token}` }
                                    });
                                    if (res.ok) {
                                      fetchTrashFiles();
                                      fetchFolderStructure();
                                      setSnackbar({ open: true, message: 'Файл відновлено', severity: 'success' });
                                    }
                                  }}
                                >
                                  <RestoreIcon />
                                </IconButton>
                                <IconButton 
                                  color="error" 
                                  title="Видалити остаточно"
                                  onClick={async () => {
                                    if (window.confirm('Ви впевнені, що хочете видалити цей файл НАЗАВЖДИ?')) {
                                      const token = localStorage.getItem('token');
                                      const res = await fetch(`${API_URL}/api/trash/${file.id}`, {
                                        method: 'DELETE',
                                        headers: { 'Authorization': `Bearer ${token}` }
                                      });
                                      if (res.ok) {
                                        fetchTrashFiles();
                                        setSnackbar({ open: true, message: 'Файл видалено назавжди', severity: 'info' });
                                      }
                                    }
                                  }}
                                >
                                  <DeleteForeverIcon />
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            <Snackbar
              open={snackbar.open}
              autoHideDuration={6000}
              onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
              <Alert
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
          </Box>
        </Box>
        {/* Футер */}
        <Box component="footer" sx={{
          width: '100%',
          bgcolor: 'grey.100',
          color: 'text.secondary',
          py: 2,
          px: 0,
          mt: 4,
          borderTop: '1px solid #e0e0e0',
          textAlign: 'center',
          position: 'relative',
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <img src={IDlogo} alt="logo-mini" style={{ height: 28, borderRadius: 4 }} />
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              © {new Date().getFullYear()} IT-Documentum. Всі права захищені.
            </Typography>
          </Box>
        </Box>
      </Box>
    </AuthContext.Provider>
  );
}

export default App; 